import { useMemo } from "react";
import { useResource, useRetrieve } from "@rest-hooks/core";
import { loadTenantSettings } from "../endpoints/loadTenantSettings";
import { loadIntlMessages } from "../endpoints/loadIntlMessages";
import { useBrandSettings } from "./useBrandSettings";
import { useLanguageSettings, localeLang } from "./useLanguageSettings";
export function useTenantSettings(tenantName, loaders, currentLocale, defaultLocale, themeImages = {}) {
    const tenant = useResource(loadTenantSettings, {
        tenantName,
        loader: loaders.tenant
    });
    const { locale, messages, formats } = useLanguageSettings(tenant, loaders.messages, currentLocale, defaultLocale);
    let language = localeLang(locale);
    // Initiate loading of default messages early.
    useRetrieve(loadIntlMessages, {
        language,
        loader: loaders.messages
    });
    const { brand } = useBrandSettings(themeImages);
    return useMemo(() => ({
        locale,
        tenant,
        messages,
        formats,
        brand
    }), [brand, formats, locale, messages, tenant]);
}
//# sourceMappingURL=useTenantSettings.js.map